import {createSlice, createSelector} from '@reduxjs/toolkit';

// import {INIT} from './../constants/status';

const initialState = {
    cart: [],
    drawerCart: false,
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        setCart: (state, action) => {
            localStorage.setItem('cart', JSON.stringify(action.payload));
            state.cart = action.payload;
        },
        addToCart: (state, action) => {
            localStorage.setItem('cart', JSON.stringify([...state.cart,action.payload]));
            state.cart = [...state.cart,action.payload]
        },
        removeOfCart: (state, action) => {
            localStorage.setItem('cart', JSON.stringify(state.cart.filter(item => item.product_id !== action.payload)));
            state.cart = state.cart.filter(item => item.product_id !== action.payload)
        },
        incrementOfProduct: (state, action) =>{
            let cart = [...state.cart];
            cart.filter(x => x.product_id === action.payload)[0].quantity += 1;
            localStorage.setItem('cart', JSON.stringify(cart));
            state.cart = cart
        },
        decrementOfProduct: (state, action) =>{
            let cart = [...state.cart];
            cart.filter(x => x.product_id === action.payload)[0].quantity -= 1;
            localStorage.setItem('cart', JSON.stringify(cart));
            state.cart = cart
        },
        setDrawerCart: (state, action) => {
            state.drawerCart = action.payload;
        },
    },
});

export const {actions} = cartSlice;
export const {setCart, setDrawerCart, addToCart, removeOfCart, incrementOfProduct, decrementOfProduct} = actions;

// selectors
export const selCart = (state) => state.cart.cart;
export const selDrawerCart = (state) => state.cart.drawerCart;


const reducer = {
    cart: cartSlice.reducer,
};
export default reducer;